import React, { useEffect } from "react";

import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";
import { Col, Row } from "react-bootstrap";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import {
  PLTFormat,
  PLTNormalFan,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Profit And Loss/ProfitAndLossSlice";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function StatementT_Format({ selectedIds, ToDate, Fromdate }) {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { PLTFormatdata } = useSelector((state) => state.ProFitAndLossSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const Year = Cookies.get("FinancialYear");  

  useEffect(() => {
    dispatch(PLTNormalFan());
    dispatch(PLTFormat({ Firm, Year, selectedIds, Fromdate, ToDate }));
  }, [dispatch, Firm, Year, selectedIds, Fromdate, ToDate]);


  /* ================= DATA MAPPING ================= */

  const tradingIncomeData =
    PLTFormatdata?.TrCrDetail?.map((item, index) => ({
      srNumber: index + 1,
      group: "Trading Income",
      subGroup: item.GroupMStName,
      AcLaieName: item.AcLaieName,
      GroupMStName: item.GroupMStName,
      acname: item.acname,
      CrAmt: item.CrAmt,
    })) || [];

  const tradingExpenseData =
    PLTFormatdata?.TrDrDetail?.map((item, index) => ({
      srNumber: index + 1,
      group: "Trading Expense",
      subGroup: item.GroupMStName,
      AcLaieName: item.AcLaieName,
      GroupMStName: item.GroupMStName,
      acname: item.acname,
      DrAmt: item.DrAmt,
    })) || [];

  const plIncomeData =
    PLTFormatdata?.PrCrDetail?.map((item, index) => ({
      srNumber: index + 1,
      group: "P&L Income",
      subGroup: item.GroupMStName,
      AcLaieName: item.AcLaieName,
      GroupMStName: item.GroupMStName,
      acname: item.acname,
      CrAmt: item.CrAmt,
    })) || [];

  const plExpenseData =
    PLTFormatdata?.PrDrDetail?.map((item, index) => ({
      srNumber: index + 1,
      group: "P&L Expense",
      subGroup: item.GroupMStName,
      AcLaieName: item.AcLaieName,
      GroupMStName: item.GroupMStName,
      acname: item.acname,
      DrAmt: item.DrAmt,
    })) || [];

  /* ================= COLUMNS ================= */

  const creditColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Account Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Credit", key: "CrAmt", align: "right", format: true },
  ];

  const debitColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Account Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Debit", key: "DrAmt", align: "right", format: true },
  ];

  /* ================= UI STYLES ================= */

  const cardWrapStyle = {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
  };

  const headerStyle = {
    backgroundColor:
      isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
    color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
    padding: "14px",
    margin: 0,
  };

  const titleStyle = {
    fontSize: "18px",
    margin: 0,
    letterSpacing: "1px",
    fontWeight: "600",
  };

  const subHeadingStyle = {
    fontSize: "13px",
    opacity: 0.9,
    marginLeft: "10px",
  };

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    let startY = 20;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Profit & Loss - T Format Statement", pageWidth / 2, 12, {
      align: "center",
    });

    doc.line(marginX, 15, pageWidth - marginX, 15);

    /* ================= FIRM NAME ================= */
    const firmName = DataMain?.Firm_List?.[0]?.GroupName || "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    if (firmName) {
      doc.text(firmName, pageWidth / 2, startY, { align: "center" });
    } else {
      doc.text(" ", pageWidth / 2, startY);
    }

    startY += 8;

    /* ================= HELPERS ================= */
    const formatAmount = (v) =>
      Number(v || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
      });


    const tableWidth = 190;
    const leftMargin = (pageWidth - tableWidth) / 2;

    /* ================= TABLE RENDER FUNCTION ================= */
    const renderTable = (title, rows, columns, totalLabel) => {
      if (!rows.length) return;

      doc.setFontSize(11);
      doc.setFont(undefined, "bold");
      doc.text(title, pageWidth / 2, startY, { align: "center" });

      startY += 5;

      const body = [
        ...rows,
        [
          "",
          "",
          "",
          totalLabel,
          formatAmount(
            rows.reduce((s, r) => s + Number(r[4].replace(/,/g, "") || 0), 0),
          ),
        ],
      ];

      autoTable(doc, {
        startY,
        margin: { left: leftMargin },

        head: [columns],

        body,

        theme: "grid",
        styles: {
          fontSize: 8,
          valign: "middle",
          textColor: [0, 0, 0],
          lineColor: [210, 210, 210],
          lineWidth: 0.2,
        },

        headStyles: {
          fillColor: [220, 220, 220],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
          fontSize: 9,
        },

        bodyStyles: {
          fontStyle: "bold",
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 15 },
          1: { cellWidth: 35 },
          2: { cellWidth: 45 },
          3: { cellWidth: 60 },
          4: { halign: "right", cellWidth: 30 },
        },

        didParseCell(data) {
          if (data.row.raw?.[3] === totalLabel) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [235, 235, 235];
          }
        },
      });

      startY = doc.lastAutoTable.finalY + 12;

      if (startY > pageHeight - 30) {
        doc.addPage();
        startY = 20;
      }
    };

    /* ================= DATA ================= */
    const trCr = tradingIncomeData.map((r, i) => [
      i + 1,
      r.AcLaieName,
      r.GroupMStName,
      r.acname,
      formatAmount(r.CrAmt),
    ]);

    const trDr = tradingExpenseData.map((r, i) => [
      i + 1,
      r.AcLaieName,
      r.GroupMStName,
      r.acname,
      formatAmount(r.DrAmt),
    ]);

    const prCr = plIncomeData.map((r, i) => [
      i + 1,
      r.AcLaieName,
      r.GroupMStName,
      r.acname,
      formatAmount(r.CrAmt),
    ]);

    const prDr = plExpenseData.map((r, i) => [
      i + 1,
      r.AcLaieName,
      r.GroupMStName,
      r.acname,
      formatAmount(r.DrAmt),
    ]);

    /* ================= RENDER ALL ================= */

    renderTable(
      "Trading Income",
      trCr,
      ["Sr", "Ac Type", "Ac Group", "Account Name", "Credit"],
      "TOTAL",
    );

    renderTable(
      "Trading Expense",
      trDr,
      ["Sr", "Ac Type", "Ac Group", "Account Name", "Debit"],
      "TOTAL",
    );

    renderTable(
      "P&L Income",
      prCr,
      ["Sr", "Ac Type", "Ac Group", "Account Name", "Credit"],
      "TOTAL",
    );

    renderTable(
      "P&L Expense",
      prDr,
      ["Sr", "Ac Type", "Ac Group", "Account Name", "Debit"],
      "TOTAL",
    );

    /* ================= SAVE ================= */
    doc.save("PL_T_Format.pdf");
  };

  if (PLTFormatdata === "no" || PLTFormatdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>
      <Row className="g-4">
        {/* ===== TRADING INCOME ===== */}
        <Col xs={12}>
          <div style={cardWrapStyle}>
            <div style={headerStyle}>
              <h5 style={titleStyle}>Statement T Format</h5>
              <p style={subHeadingStyle}>Trading Income Detail</p>
            </div>

            {/* <FASparentMultipalChild
              columns={creditColumns}
              data={tradingIncomeData}
              parentKey="AcLaieName"
              childKey="GroupMStName"
              externalTotals={PLTFormatdata?.TrCrSummary?.[0]}
            /> */}
            <FASparentMultipalChild
              columns={creditColumns}
              data={tradingIncomeData}
              externalTotals={PLTFormatdata?.TrCrSummary?.[0] || {}}
            />
          </div>
        </Col>

        {/* ===== TRADING EXPENSE ===== */}
        <Col xs={12}>
          <div style={cardWrapStyle}>
            <div style={headerStyle}>
              <h5 style={titleStyle}>Trading Expenses</h5>
              <p style={subHeadingStyle}>Trading Expenses Detail</p>
            </div>

            {/* <FASparentMultipalChild
              columns={debitColumns}
              data={tradingExpenseData}
              parentKey="AcLaieName"
              childKey="GroupMStName"
            /> */}
            <FASparentMultipalChild
              columns={debitColumns}
              data={tradingExpenseData}
              externalTotals={PLTFormatdata?.TrDrSummary?.[0] || {}}
            />
          </div>
        </Col>

        {/* ===== P&L INCOME ===== */}
        <Col xs={12}>
          <div style={cardWrapStyle}>
            <div style={headerStyle}>
              <h5 style={titleStyle}>Profit & Loss Account</h5>
              <p style={subHeadingStyle}>P&L Income Detail</p>
            </div>
            {/* <FASparentMultipalChild
              columns={creditColumns}
              data={plIncomeData}
              parentKey="AcLaieName"
              childKey="GroupMStName"
              externalTotals={PLTFormatdata?.PrCrSummary?.[0]}
            /> */}

            <FASparentMultipalChild
              columns={creditColumns}
              data={plIncomeData}
              externalTotals={PLTFormatdata?.PrCrSummary?.[0] || {}}
            />
          </div>
        </Col>

        {/* ===== P&L EXPENSE ===== */}
        <Col xs={12}>
          <div style={cardWrapStyle}>
            <div style={headerStyle}>
              <h5 style={titleStyle}>P&L Expenses</h5>
              <p style={subHeadingStyle}>P&L Expenses Detail</p>
            </div>
            {/* 
            <FASparentMultipalChild
              columns={debitColumns}
              data={plExpenseData}
              parentKey="AcLaieName"
              childKey="GroupMStName"
            /> */}

            <FASparentMultipalChild
              columns={debitColumns}
              data={plExpenseData}
              externalTotals={PLTFormatdata?.PrDrSummary?.[0] || {}}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
